import React from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'jsonapi-react'
import { Helmet } from 'react-helmet-async'
import { Layout, Sidebar, TwoColumns } from 'app/theme/layout'
import BookTruckBanner from 'app/theme/banners/BookTruckBar'
import ShadowBox from 'app/caterers/ShadowBox'
import Pagination from 'app/theme/Pagination'
import NotFoundPage from 'app/pages/NotFoundPage'

export default function SearchPage() {
  const { term, page } = useParams()

  const path = `/food-trucks/`

  const displayTerm = term.split(' ').map(s =>
    s.charAt(0).toUpperCase() + s.slice(1)
  ).join(' ')

  const query = useQuery(['caterers', {
    sort: '-ranking',
    filter: {
      search: term,
    },
    include: [
      'photo',
    ],
    fields: {
      caterers: ['name', 'slug'],
      photos: ['uuid', 'extension', 'path']
    },
    page: {
      number: page || 1,
      size: 21
    },
    stats: {
      total: 'count',
    }
  }])

  let caterers = query.data ? [...query.data] : []

  if (caterers.length) {
    caterers.splice(3, 0, 'banner')
  }

  const pageOutOfRange = page && Math.ceil(query.meta?.stats?.total?.count / 21) < page

  if (pageOutOfRange) {
    return <NotFoundPage />
  }

  return (
    <Layout className="container py-10">
      <Helmet>
        <title>{displayTerm} Food Trucks</title>
        <meta name="description" content={`Top Search Results for ${displayTerm} Food Trucks`}></meta>
        <meta name="og:title" content={`${displayTerm} Food Trucks`}></meta>
        {(page && page > 1) && (
          <meta name="robots" content="noindex" />
        )}
      </Helmet>
      <TwoColumns sidebar={<Sidebar />}>
        <div className="mt-4 flex items-center border-b border-gray-300 pb-3 mb-6">
          <h1 className="text-3xl lg:text-4xl text-navy font-platform leading-tight">
            Food Truck Search
          </h1>
        </div>
        {caterers.length > 0 && (
          <div className="text-2xl leading-none mb-6">
            Search results for "{displayTerm}" Food Trucks and "{displayTerm}" Food Carts
          </div>
        )}
        <div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 lg:gap-6">
            {caterers.map((caterer, index) => (
              caterer === 'banner' ? (
                <BookTruckBanner
                  key="banner"
                  className="col-span-3 hidden md:flex"
                  url='/food-truck-catering'
                />
              ) : (
                <ShadowBox
                  key={caterer.id}
                  caterer={caterer}
                  photo={caterer.photo}
                />
              )
            ))}
          </div>
          {!caterers.length && (
            <div className="text-navy text-xl">
              Sorry, we couldn't find any trucks or carts matching "{displayTerm}".
            </div>
          )}
          {query.meta && (
            <Pagination
              className="justify-center mt-10"
              total={query.meta.stats.total.count}
              current={page || 1}
              limit={21}
              getLinkProps={link => ({
                href: link.page === 1
                  ? `/food-trucks/search/${term}/`
                  : `/food-trucks/search/${term}/${link.page}/`
              })}
            />
          )}
        </div>
      </TwoColumns>
    </Layout>
  )
}
